<template>
<div class="view">

<div class="daruma credits">Created by @mattkingz - Art by @pez_moreno</div>

<div class="panel jp-antique">
    <div v-if="currentChar" :class="`${animChar} ${currentChar.length == 2 ? 'two-char' : ''}`">{{currentChar}}</div>
    <div class="daruma help char-idle" v-if="help">{{help}}</div>
</div>

<!--<img :src="require('../assets/momo_1.png')" alt="" width="200">-->
<div :class="`momo ${momoAnimation}`"></div>

<input v-model="txtInput" type="text" 
@keyup.enter="SubmitAnswer" ref="txtInput" class="reading-input" 
@blur="$refs.txtInput.focus()"/>

</div>
</template>

<script>
import random from 'random'
export default {
    data() {
        return {
            sets: {},
            currentChar: '',
            lastChar: '',
            txtInput: '',
            momoAnimation: 'momo-idle',
            animChar: 'char-idle',
            isWaiting: false,
            help: '',
        }
    },
    mounted() {

        setTimeout(() => {
            
            this.$refs.txtInput.focus();
            this.$refs.txtInput.click();
        }, 100);

        for(let key in this.dictionary)
        {
            let char = this.dictionary[key];
            if(!this.sets[char.set]) this.sets[char.set] = [];
            this.sets[char.set].push(key);
        }

        
        this.NextCharacter();
        

    },
    methods: {
        SubmitAnswer() {
            if(this.isWaiting) return;

            let char = this.dictionary[this.currentChar];
            let isCorrect = this.txtInput.toLowerCase().trim() == char.pronunciation;
            
            char.reading.push(isCorrect);
            if(char.reading.length > 10) char.reading.shift();
            if(isCorrect)
            {
                char.readingScore += 1 + char.readingCombo;
                char.readingCombo += 1;
                if(char.readingScore > 10) char.readingScore = 10;
            }
            else
            {
                char.readingScore -= 1 - (char.readingCombo == 0 ? 1 : 0);
                char.readingCombo = 0;
                if(char.readingScore < 0) char.readingScore = 0;
            }
            this.$store.commit('UpdateChar', {key: this.currentChar, data: char});
            //console.log(`[${this.currentLevel}] ${this.currentChar} ${char.readingScore}/10 combo(${char.readingCombo})`);

            this.lastChar = this.currentChar;

            this.CheckLevelCompleted();

            if(isCorrect) this.CorrectAnswer();
            else this.WrongAnswer(char.pronunciation);

            this.txtInput = '';
            //this.NextCharacter();
            
        },
        NextCharacter() {
            //let set = this.GetCurrentSet();
            //console.log(`current set is ${set}`);

            this.currentChar = this.GetRandomCharacter();
        },
        /*
        GetCurrentSet() {
            let currentSet = 0;
            for(let key in this.sets)
            {
                currentSet = parseInt(key);
                let set = this.sets[key];
                for(let i = 0; i < set.length; i++)
                {
                    if(this.ReadingProgress(set[i]) < 70) return currentSet;
                }
            }
            return currentSet+1;
        },
        
        ReadingProgress(c)
        {
            let char = this.dictionary[c];
            let total = 0;
            for(let i = 0; i < char.reading.length; i++)
            {
                total += char.reading[i] ? 10 : -5;
            }
            console.log(`reading progress of ${c} is ${total}`);
            return total;
        },
        */
        GetRandomCharacter()
        {
            let options = [];
            for(let key in this.sets)
            {
                let currentSet = parseInt(key);
                if(currentSet <= this.currentLevel) options = options.concat(this.sets[key]);
            }

            let rankedOptions = [];
            let minProgress = 10;
            options.forEach(option => {
                //let readingProgress = this.ReadingProgress(option);
                let score = this.dictionary[option].readingScore;
                if(score < minProgress) minProgress = score;
                rankedOptions.push({
                    char: option,
                    score: score
                });
            });

            if(minProgress <= 5) minProgress = 5;
            else if(minProgress <= 9) minProgress = 9;
            else minProgress = 10;

            let filteredOptions = rankedOptions.filter(option => {return option.score <= minProgress});
            
            if(filteredOptions.length > 1 && this.lastChar)
            {
                filteredOptions = filteredOptions.filter(option => {return option.char !== this.lastChar});
            }

            return random.choice(filteredOptions).char;
        },
        CorrectAnswer() 
        {
            this.isWaiting = true;
            this.momoAnimation = 'momo-correct';
            this.animChar = 'char-correct';
            setTimeout(() => {
                this.momoAnimation = 'momo-idle';
                this.animChar = 'char-idle';
                this.isWaiting = false;
                this.NextCharacter();
            }, 1050);
            
        },
        WrongAnswer(help) 
        {
            this.isWaiting = true;
            this.momoAnimation = 'momo-wrong';
            this.animChar = 'char-wrong';
            setTimeout(() => {
                this.animChar = 'char-wrong-min';
                this.help = help;
                setTimeout(() => {
                    this.momoAnimation = 'momo-idle';
                    this.animChar = 'char-idle';
                    this.isWaiting = false;
                    this.help = '';
                    this.NextCharacter();
                }, 1500);
            }, 500);
        },
        CheckLevelCompleted() {
            let options = [];
            for(let key in this.sets)
            {
                let currentSet = parseInt(key);
                if(currentSet <= this.currentLevel) options = options.concat(this.sets[key]);
            }

            for(let i = 0; i < options.length; i++)
            {
                let char = this.dictionary[options[i]];
                if(char.readingScore < 10) return;
            }

            for(let i = 0; i < options.length; i++)
            {
                let char = this.dictionary[options[i]];
                char.readingScore = 0;
                this.$store.commit('UpdateChar', {key: options[i], data: char});
            }
            
            this.$store.commit('ReadingLevelUp');
        }
    },
    computed: {
        currentLevel() {
            return this.$store.state.readingLevel;
        },
        dictionary() {
            return this.$store.state.dictionary;
        },
    },
    watch: {
        txtInput: function(n, o) {
            if(this.isWaiting && n) this.txtInput = '';
        }
    }
}
</script>

<style lang="scss">
.view {
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.panel {
    background-image: url('~@/assets/panel.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 110px;
    padding-bottom: 10px;
    position: relative;
}

.help {
    position: absolute;
    bottom: 30px;
    width: 100%;
    text-align: center;
    font-size: 30px;
}

.jp-antique {
    font-family: 'Zen Kaku Gothic Antique', sans-serif;
}
.jp-kaku {
    font-family: 'Zen Kaku Gothic New', sans-serif;
}
.jp-maru {
    font-family: 'Zen Maru Gothic', sans-serif;
}
.jp-mincho {
    font-family: 'Zen Old Mincho', serif;
}
.daruma {
    font-family: 'Darumadrop One', cursive;
}

.reading-input {
    background-color: var(--light-blue);
    outline: 4px solid var(--light-blue);
    border: 4px solid var(--blue);
    border-radius: 10px;
    padding: 0px 10px 10px 0px;
    margin-top: 40px;
    font-size: 30px;
    color: white;
    font-weight: bold;
    text-shadow: -2px 3px var(--dark-blue);
    text-align: center;
    font-family: 'Darumadrop One', cursive;
    z-index: 1;
    max-width: 250px;
    caret-color: var(--light-blue);
}

.credits {
    position: absolute;
    top: 0;
    width: 100%;
    text-align: center;
    color: var(--light-blue);
}

.momo {
    width: 200px;
    height: 456px;
    position: absolute;
    transform: translateX(-210px);
    background-image: url('~@/assets/momo_1.png');
    background-size: 100% 100%;
    user-select: none;
}
.momo-idle {
    animation: anim-momo-idle 1s linear 0s infinite;
}
.momo-correct {
    background-image: url('~@/assets/momo_correct.png');
}
.momo-wrong {
    background-image: url('~@/assets/momo_wrong.png');
}

.char-idle {
    animation: anim-char-idle 0.3s ease-out 0s;
}
.char-correct {
    animation: anim-char-correct 1s ease-out 0s forwards;
}
.char-wrong {
    animation: horizontal-shaking 0.3s ease-out 0s;
}
.char-wrong-min {
    animation: anim-char-min 0.5s ease-out 0s forwards;
}

.two-char {
    letter-spacing: -35px;
    margin-left: -40px;
}

@keyframes anim-momo-idle {
    0%, 49.9% {
        background-image: url('~@/assets/momo_1.png');
    }
    50%, 100% {
        background-image: url('~@/assets/momo_2.png');
    }
}

@keyframes anim-char-correct {
    0% {
        transform: scale(1);
    }
    60% {
        opacity: 1;
    }
    100% {
        transform: scale(1.4);
        opacity: 0;
        color: var(--green);
    }
}
@keyframes anim-char-idle {
    0% {
        opacity: 0;
        transform: translateY(-30px);
    }
    100% {
        transform: translateY(0px);
        opacity: 1;
    }
}
@keyframes anim-char-min {
    0% {
        transform: translateY(0px) scale(1);
    }
    100% {
        transform: translateY(-20px) scale(0.75);
        color: var(--red);
    }
}
@keyframes horizontal-shaking {
 0% { transform: translateX(0) }
 25% { transform: translateX(5px) }
 50% { transform: translateX(-5px) }
 75% { transform: translateX(5px) scale(1) }
 100% { transform: translateX(0) }
}

@media (max-width: 480px) {
  .momo {
    transform: translate(-140px, -20px) scale(0.4);
  }
}

</style>